import { combineReducers } from 'redux';

import outofstockModalReducer from 'store/Comparison/outofstock/reducers';

import { commonRootReducers } from '..';
import commonReducer from './common/reducers';
import feedbackReducer from './feedback/reducers';
import feedbackLocalReducer from './feedbackLocal/reducers';
import servicesReducer from './servicesLocal/reducers';
import crossSellProductsReducer from './crossSellProducts/reducers';
import preorderReducer from './preorder/reducers';
import deliveryReducer from './delivery/reducers';
import outOfStockReducer from './outofstock/reducers';
import recentlyViewedReducer from '../widgets/recentlyViewedProducts/reducers';
import cheaperOption from './cheaperOption/reducers';
import similarProductsReducer from './similarProducts/reducers';
import detailsModalReducer from './detailsModal/reducers';
import recommendationTabsReducer from './recommendationTabs/slice';

export default combineReducers({
  ...commonRootReducers,
  // eslint-disable-next-line default-param-last
  body: (state = {}, action) => ({
    ...state,
    common: commonReducer(state.common, action),
    feedback: feedbackReducer(state.feedback, action),
    feedbackLocal: feedbackLocalReducer(state.feedbackLocal, action),
    deliveryDetails: deliveryReducer(state.deliveryDetails, action),
    preorderDetails: preorderReducer(state.preorderDetails, action),
    servicesLocal: servicesReducer(state.servicesLocal, action),
    crossSellProducts: crossSellProductsReducer(state.crossSellProducts, action),
    outOfStockDetails: outOfStockReducer(state.outOfStockDetails, action),
    recentlyViewedProducts: recentlyViewedReducer(state.recentlyViewedProducts, action),
    cheaperOption: cheaperOption(state.cheaperOption, action),
    similarProducts: similarProductsReducer(state.similarProducts, action),
    detailsModal: detailsModalReducer(state.detailsModal, action),
    outofstockModal: outofstockModalReducer(state.outofstockModal, action),
    recommendationTabs: recommendationTabsReducer(state.recommendationTabs, action),
  }),
});
